module.exports = __webpack_public_path__ + "static/media/life-faq-banner-bg.54c98af3.jpg";